@if (plans) {
  <mat-accordion [displayMode]="'flat'" [multi]="multi">
    @for (benefitCategory of plans; track $index; let i = $index) {
      <app-benefit-category
        [benefitCategory]="benefitCategory"
        [market]="market"
        [isFirstRow]="i === 0">
      </app-benefit-category>
    }
  </mat-accordion>
}
